<template>
  <div id="personnel">
    <el-card class="box-card mb15">
      <el-row :gutter="20">
        <el-col :xs="10" :sm="8" :md="8" :lg="5">
          <el-select v-model="listQuery.userRoleId" placeholder="请选择角色">
            <el-option
              v-for="(v, i) in roleTypeOptions"
              :key="i"
              :label="v.value"
              :value="v.key">
            </el-option> 
          </el-select>
        </el-col>
        <el-col :xs="10" :sm="8" :md="8" :lg="5">
          <el-input placeholder="请输入姓名" v-model="listQuery.userName" clearable></el-input>
        </el-col>
        <el-col :xs="10" :sm="8" :md="8" :lg="5">
          <el-input placeholder="请输入单位" v-model="listQuery.deptName" clearable></el-input>
        </el-col>
        <el-col style="float: left; width: 110px">
          <el-button type="primary" icon="el-icon-search" @click="getList()" style="width: 90px">搜索</el-button >
        </el-col>
        <!-- <el-col style="float: left; width: 130px">
          <el-button type="primary" @click="tempDownload()" style="width: 130px">导入模板下载</el-button >
        </el-col> -->
        <!-- <div v-show="isReduce">
          
        </div> -->
        <el-col style="float: right;width: 110px">
          <el-button type="primary" @click="showEditDialog('add')">新增用户</el-button >
        </el-col>
        <!-- <el-col style="float: right;width: 110px">
          <el-upload
            class="upload-demo"
            action = ""
            :http-request="fileImport"
            :on-change="handleChange"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
            :on-preview="handlePreview"
            multiple
            :limit="1"
            >
            <el-button  type="primary" ref="import">批量导入</el-button>
          </el-upload>
        </el-col> -->
        <!-- <el-col style="float: right;width: 140px">
          <el-button type="primary" @click="configRole()" :disabled="!isSelect">批量配置角色</el-button >
        </el-col>
        </div>
        <el-col v-show="!isSelect" style="float: right;width: 80px">
          <el-button type="primary" @click="isSelect = true">选择</el-button >
        </el-col>
        <el-col v-show="isSelect" style="float: right;width: 80px">
          <el-button type="primary" @click="isSelect = false">取消</el-button >
        </el-col> -->
        
        <!-- <div v-show="!isReduce">
          <el-dropdown style="float: right;margin-right: 10px;" @command="handleCommand">
            <el-button type="primary">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">新增用户</el-dropdown-item>
              <el-dropdown-item command="2">批量导入</el-dropdown-item>
              <el-dropdown-item :disabled="!isSelect" command="3">批量配置角色</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div> -->
      </el-row>
    </el-card>
    <el-card class="box-card mb15">
      <el-table ref="multipleTable" :data="tableData" style="width: 100%" stripe>
        <el-table-column type="selection" width="55" v-if="isSelect"></el-table-column>
        <el-table-column fixed prop="userName" label="用户"> </el-table-column>
        <el-table-column fixed prop="account" label="登陆名"> </el-table-column>
        <el-table-column prop="roleName" label="角色"> </el-table-column>
        <!-- <el-table-column prop="deptName" label="人员所属"> </el-table-column> -->
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column label="操作" width="300px">
          <template slot-scope="{ row }">
            <el-button-group>
              <el-button
                type="primary"
                size="mini"
                @click="showEditDialog('edit',row)" >编辑</el-button>
              <el-button type="danger" size="mini" @click="delUser(row)" v-if="row.account != 'admin'">删除</el-button>
              <!-- <el-button type="primary" size="mini" @click="configRole(row)">配置角色</el-button> -->
              <el-button type="warning" size="mini" @click="resettingUser(row)" >重置账号密码</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <Pagination
        style="margin-top: 20px"
        v-show="parseInt(pageObj.count) > 0"
        :total="parseInt(pageObj.count)"
        @change="getList"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
      />

      <el-dialog
      :title="addOrEdit ? '人员管理-新增' : '人员管理-编辑'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="600px"
      @close="$reset('temp')"
    >
      <el-form ref="temp" :model="temp" :rules="rules" label-width="100px">
        <el-form-item label="登陆名" prop="account" >
          <el-input v-model="temp.account" placeholder="请输入登陆账号" :disabled="!passwordShow"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="userName">
          <el-input v-model="temp.userName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-show="passwordShow">
          <el-input v-model="temp.password" show-password :placeholder="passwordTips"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword" v-show="passwordShow">
          <el-input v-model="temp.confirmPassword" show-password :placeholder="passwordTips2" ></el-input>
        </el-form-item>
        <el-form-item label="选择角色" prop="type">
          <el-select style="width:100%" v-model="temp.userRoleId" multiple placeholder="请选择角色">
            <el-option
              v-for="(v, i) in roleTypeOptions"
              :key="i"
              :label="v.value"
              :value="v.key"
            >
            </el-option>
                
          </el-select>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="temp.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="学号/工号" prop="sno">
          <el-input v-model="temp.sno" placeholder="请输入学号/工号"></el-input>
        </el-form-item>
        <!-- <el-form-item label="选择单位"  class="top_unit"> 
                <el-popover
                    placement="bottom-start"
                    v-model="treeFlag"
                    class="orgTree"
                    
                    trigger="click">
                    <el-tree
                        :data="deptData"
                        :props="defaultProps"
                        :expand-on-click-node="false"
                        node-key="id"
                        style="width: 300px;"
                      
                        @node-click="handleNodeClickDep"
                    ></el-tree>
                    <el-input
                        slot="reference"
                        ref="input"
                        v-model="treeName"
                        clearable
                        :readonly="true"
                        style="width: 100%"
                      
                        placeholder="请选择单位"
                    >
                    </el-input>

                </el-popover>

                <i  @click.stop="closeName" class="el-icon-circle-close" v-if="treeName" ></i>
                 <i  class="el-icon-arrow-down" v-else></i>
          </el-form-item> -->
          
            <!-- <el-form-item label="部门负责人" prop="isLeader" class="le-radio">
                <el-radio-group v-model="temp.isLeader">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="2">否</el-radio>
                </el-radio-group>
            </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="dialogFormVisible = false;treeName = '';">取 消</el-button>
        <el-button v-show="!addOrEdit" type="primary" @click="handleUpdate()">提 交</el-button>
        <el-button v-show="addOrEdit" type="primary" @click="VerifyAccountNumber()">新 增</el-button>
      </div>
      </el-dialog>
      <el-dialog
      :title="'角色配置'"
      :visible.sync="roleConfigVisible"
      :close-on-click-modal="false"
      width="400px"
      @close="$reset('rtemp')"
    >
      <el-form ref="rtemp" label-width="80px">
        <el-form-item>
          <el-checkbox-group v-model="checkList">
            <el-checkbox style="width:100%" v-for="(v, i) in roleTypeOptions"
              :key="i"
              :label="v.key">{{v.value}}</el-checkbox>
          </el-checkbox-group>
          
        </el-form-item>    
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="roleConfigVisible = false">取消</el-button>
        <el-button type="primary" @click="configUserSave">确定</el-button>
      </div>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
 
import axios from 'axios';
import {
  tbSysPersonnelQuery,
  tbSysPersonnelAdd,
  tbSysPersonnelVerify,
  tbSysPersonnelUpdate,
  tbSysPersonnelDelete,
  tbSysPersonnelUpdatePassword,
  tbSysPersonnelUpdateUserRole,
  tbSysPersonnelTempDownload,
  tbSysPersonnelBatchImport
} from "@/api/personnelManagement";
import { tbSysRoleQuery} from "@/api/http";
import {tbDeptTreeList} from "@/api/programmeManagement";
export default {
  
  created() {
    this.getList();
    this.getRoleList();
    this.getDeptLsit();
    if(`${document.documentElement.clientWidth}` < 1812){
       this.isReduce = false;
      }else{
        this.isReduce = true;
      }
  },
  data() {
    // 重复密码验证
    const pwdAgainCheck = async(rule, value, callback) => {
      //这样才能在回调里通过箭头函数获取到this对象
      if(value != this.temp.password){
        callback(new Error("与密码不一致"));
      }else {
        //校验通过
        callback();
      }
    };
    return {
      width: `${document.documentElement.clientWidth}`,
      temp: {isLeader:"1"},
      checkList :[],
      roleTypeOptions:[],
      fileList:[],
      configRoleList:[],
      isReduce:true,
      isSelect:false,
      addOrEdit:true,
      radio:"1",
      passwordShow:true,
      listQuery: {
        page: 1,
        limit: 10,
        userName:"",
        deptName: "",
        userRoleId:"",
        del:1,
      },
      defaultProps: {
        children: 'childList',
        label: 'name'
      },
      tableData: [],
      deptData:[],
      dialogVisible: false,
      dialogFormVisible: false,
      roleConfigVisible:false,
      fileUploadVisible:false,
      pageObj: {},
      treeFlag:false,
      treeName:"",
      passwordTips:"",
      passwordTips2:"",
      fileTemp:"",
      rules: {
        account: [
          { required: true, message: "请输入登录名", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "请输入3~15个字符",
            trigger: "blur",
          },
        ],
        userName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            validator: function(rule, value, callback) {
              //校验中文的正则：/^[\u4e00-\u9fa5]{0,}$/
              if (/^[\u4e00-\u9fa5]{2,8}$/.test(value) == false) {
                callback(new Error("请输入2~8个汉字"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "请输入8~16个字符（包含数字、字母、特殊符号中的任意两种）", trigger: "blur" },
          {
            validator: function(rule, value, callback){
              //校验中文的正则：/^[\u4e00-\u9fa5]{0,}$/
              //^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{8,}$ 三种
              //^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$
              if (/(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{8,16}$/.test(value) == false) {
                callback(new Error("请输入8~16个字符（包含数字、字母、特殊符号中的任意两种）"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          {
            validator: pwdAgainCheck,
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { type: 'number', validator: function(rule, value, callback){
              if (/^1[345789]\d{9}$/.test(value) == false) {
                callback(new Error('请输入11位手机号'));
              } else {
                //校验通过
                callback();
              }
            }, message: '请输入11位有效手机号号码', trigger: ['blur', 'change'] }
        ],
        sno:[{ required: true, message: "请填写学号或工号", trigger: "blur" },],
      },
    }
  },
  components: {
    
  },
  methods:{
    //模板下载
    tempDownload(){
      window.location.href = axios.defaults.baseURL+"tbSysUser/down";
      //tbSysPersonnelTempDownload();
    },
    // 清空单位
    closeName(){
      this.treeName="";
    },
    //验证账号是否存在
    VerifyAccountNumber(){
      tbSysPersonnelVerify({'account':this.temp.account}).then((res) => {
          if(res.data.code === '0'){
            this.handleAdd('temp');
          }else{
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
      })
    },
    //新增
    handleAdd(temp) {
      const loading = this.openLoading(); 
      this.temp.opertype = 3;
      this.temp.userRoleId = this.temp.userRoleId.toString();
      this.$refs[temp].validate((valid) => {
        if (valid) {
          this.$delete(this.temp,"confirmPassword")
          tbSysPersonnelAdd(this.temp).then((res) => {
            if(res.data.code === '0'){
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.dialogFormVisible = false;
                this.getList();
            }else{
              this.$message({
                  message: res.data.msg,
                  type: "error",
                });
            }
            loading.close(); 
              
          });
        }
      });
    },
    //修改
    handleUpdate(){
      const loading = this.openLoading(); 
      this.temp.opertype = 2;
      this.temp.userRoleId = this.temp.userRoleId.toString();

      //verifyByUser用户新增修改验证用户名是否重复
      tbSysPersonnelUpdate(this.temp).then((res)=>{
        if(res.data.code === '0'){
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.dialogFormVisible = false;
                this.getList();
            }else{
              this.$message({
                  message: res.data.msg,
                  type: "error",
                });
            }
        loading.close(); 
      })
    },
     // 选中上一级单位
        handleNodeClickDep(val){
          this.treeName = val.name;
          this.treeFlag = false;
          this.temp.deptId=val.id;
        },
    //查询所有
    getList() {
      tbSysPersonnelQuery(this.listQuery).then((res) => {
        for(let arr of res.data.data){
          if(arr.hasOwnProperty("userRoleId"))
          arr.userRoleId = arr.userRoleId.split(',');
        }
        this.tableData = res.data.data;
        this.pageObj = res.data;
      });
    },
    //查询所有角色
    getRoleList() {
      tbSysRoleQuery().then((res) => {
        let arr = [];
        for(let role of res.data.data){
          let list = {};
          list['key'] = role.id;
          list['value'] = role.name;
          arr.push(list);
        }
        this.roleTypeOptions = arr;
      });
    },
    //删除
    delUser(row){
        this.temp = { ...row}
        this.$confirm('删除人员将严重影响平台功能, 是否删除?', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.openLoading(); 
          let arr =  {id:this.temp.id,account:this.temp.account,opertype:1};
          tbSysPersonnelDelete(arr).then((res) =>{
            if (res.data.code == 0) {
              this.$message({
                  message: res.data.msg,
                  type: "success",
                });
            } else {
              this.$message({
                  message: res.data.msg,
                  type: "error",
                });
            }
            this.dialogVisible = false;
            this.getList();
            loading.close(); 
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    //查询所有部门
    getDeptLsit(){
      tbDeptTreeList().then((res) => {
        this.deptData = res.data.data;      
      });
    },
    //新增/编辑弹框
    showEditDialog(type, row) {
      if (type == "add") {
        this.addOrEdit = true;
        this.temp = { ...row };
        this.treeName = '';
        this.passwordShow = true;
      } else {
        this.addOrEdit = false;
        this.passwordShow = false;
        this.temp = { ...row };
        this.treeName = row.deptName;
      }
      this.dialogFormVisible = true;
       
    },
    //点击配置角色按钮
    configRole(){
      this.configRoleList = [];
      this.roleConfigVisible = true;
      this.configRoleList = this.$refs.multipleTable.selection;
      
    },
    configUserSave(){
      const loading = this.openLoading(); 
      let arr = [];
      for(let ros of this.configRoleList){
        ros.roles = this.checkList;
        ros.opertype = 5;
        this.$delete(ros,"userRoleId");
        arr.push(ros);
      }
      tbSysPersonnelUpdateUserRole(arr).then((res)=>{
        if (res.data.code == 0) {
              this.$message({
                  message: res.data.msg,
                  type: "success",
              });
              this.roleConfigVisible = false;
              this.checkList = [];
              this.getList();
            } else {
              this.$message({
                  message: res.data.msg,
                  type: "error",
                });
            }
            loading.close(); 
      })
    },
    //重置账号密码
    resettingUser(row){
      this.temp = { ...row}
        this.$confirm('重置账号将初始化账号密码, 是否重置?', '提示', {
          confirmButtonText: '重置',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.openLoading(); 
          tbSysPersonnelUpdatePassword({id:this.temp.id,opertype:6}).then((res) =>{
            if (res.data.code == 0) {
              this.$message({
                  message: res.data.msg,
                  type: "success",
              });
            } else {
              this.$message({
                  message: res.data.msg,
                  type: "error",
                });
            }
            loading.close(); 
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重置'
          });          
        });
    },
    //文件导入
    fileImport(){
      let formdata = new FormData();
      formdata.append("file", this.fileTemp);
      tbSysPersonnelBatchImport(formdata).then((res)=>{
        if(res.data.code === "0"){
          this.$message.success(res.data.msg);
          this.getList();
        }else{
          this.$message.error(res.data.msg);
        }
      });

    },
      handleChange(file, fileList) {
        this.fileTemp = file.raw;
      },
      handleRemove(file, fileList) {
        this.fileTemp = null;
      },
      handlePreview(file) {

      },
      handleExceed(files, fileList) {
        this.$message.warning("当前限制选择 1 个文件，请删除后继续上传");
      },
    //用户点击更多操作
	  handleCommand(command){
      switch (command) {
        case '1': 
          this.showEditDialog('add');
          break;
        case '2': 
          this.$refs.import.$el.click();
          break;
        case '3': 
          this.configRole();
          break;
        default:
          
          break;
      }
	  },
    
    
  },
  mounted() {
    const _this = this;
    window.onresize = () => {
      return (() => {
        _this.width = `${document.documentElement.clientWidth}`;
      })();
      };
  },
  watch: {
    //监测浏览器宽度对按钮做出改变
    width (val) {  
      if(!this.timer) {
        this.width = val
        this.timer = true
        let _this = this
        setTimeout(function () {
          _this.timer = false
        }, 500)
      }
      // 这里可以添加修改时的方法
      if(val < 1812){
       this.isReduce = false;
      }else{
        this.isReduce = true;
      }
    },
    //监听是修改还是新增的  改变密码框的提示
    addOrEdit(val){
      if(val){
        this.passwordTips = "请输入密码";
        this.passwordTips2 = "请再次输入密码";
      }else{
        this.passwordTips = "如果不需要修改密码，则无需填写";
        this.passwordTips2 = "如果不需要修改密码，则无需填写";
      }
    }
  },
}
</script>
<style scoped>
.el-col-lg-5 {
    width: 16.83333%;
}
.sea-span{
  width: 20%;
}
.sea-input{
  width: 70%;
  margin-left: 10px;
}
</style>
<style>
#personnel .el-form-item.top_unit i.el-icon-circle-close, .el-form-item.top_unit i.el-icon-arrow-down{
        position: absolute;
        right: 10px;
        top: 13px;
        cursor: pointer;
    }
</style>